/** For console logging in dev environment */
export const Logger = {
  console: (...text) =>
    process.env.REACT_APP_ENV === "dev" && console.log("%c🛠️ [log]:", "background: #303030; color: #fff", ...text),
  info: (...text) => process.env.REACT_APP_ENV === "dev" && console.log("%c🛠️ [info]:", "color: #2196f3", ...text),
  warn: (...text) => process.env.REACT_APP_ENV === "dev" && console.log("%c🛠️ [warn]:", "color: #ff9800", ...text),
  error: (...text) => process.env.REACT_APP_ENV === "dev" && console.log("%c🛠️ [error]:", "color: #f44336", ...text),
};
